import HeaderDataActiveMenuContextProvider from '@/finsight/ui/common/components/header/Header/HeaderMenuActiveDataContext';
import HeaderLayout from '@/finsight/ui/common/components/header/HeaderLayout';
import HeaderMenuContextProvider from '@/finsight/ui/common/components/header/Header/HeaderMenuContext';
import linksConfig from './linksConfig';

const FinsightHeaderContainer = () => (
  <HeaderMenuContextProvider>
    <HeaderDataActiveMenuContextProvider>
      <HeaderLayout
        isVisibleMarketDataMenu={ false }
        isVisibleSearch={ false }
        isVisibleLogin={ false }
        linksConfig={ linksConfig }
        isIgnoreUserPlan
      />
    </HeaderDataActiveMenuContextProvider>
  </HeaderMenuContextProvider>
);

export default FinsightHeaderContainer;
